export default __webpack_public_path__ + "static/leva-incastro-bq-1-4d23ebaf87115bbb1558ae9a6fdd019d.jpg";